import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { TourGuideContent } from '@app/util/tour-guide-content.util';
import { Subscription } from 'rxjs';
import { Messages as msg } from '@app/util/messages';
import { TourGuideService } from '@app/services/tour-guide.service';
import { MatSelect } from '@angular/material/select';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
@Component({
  selector: 'app-common-table-with-edit',
  templateUrl: './common-table-with-edit.component.html',
  styleUrls: ['./common-table-with-edit.component.scss']
})
export class CommonTableWithEditComponent implements OnDestroy {

  /****************** Variable declaration ******************/
  qualityGatesArray: any = []
  flag: boolean = false;
  displayedColumns: string[] = ['checkbox', 'tool', 'name', 'description', 'condition', 'threshold', 'failure'];
  dataSource = new MatTableDataSource<any>([]);
  thresholdTrueArray: any = [];
  updateThreshHoldObj: any = {
    "added": [],
    "updated": [],
    "deleted": []
  }
  tourGuideIds = TourGuideContent;
  dataSubscription: Subscription;
  operatorList: string[] = ["<", ">", "<=", ">="] //operator list
  getNoData = msg.tools_thresholds_no_data;

  /****************** View child ******************/
  @ViewChild('select') matSelect: MatSelect;

  /****************** Input and Output decorators ******************/
  @Input('isEditable') isEditable: boolean;
  @Input() mode: any;
  @Input() set toolThresholdList(data: any) {
    if (data?.length) {
      this.dataSource = new MatTableDataSource<any>(data);
      let parseData = JSON.parse(JSON.stringify(data))
      this.thresholdTrueArray = parseData?.filter((el: any) => el.checkbox) || []
    }
  }

  @Input() set updQgCheckFlag(flag: boolean) {
    if(!flag) {
      this.dataSource.data.forEach(element => {
        if(element.checkbox) {
          element.checkbox = false;
          this.addQualityGates(element);
        }
      });
    }
  }
  
  @Output() updQgCheckFlagChange = new EventEmitter<boolean>();
  @Output() addThreshHoldOutput = new EventEmitter<any>();

  /**
   * Constructor
   * @param guideService 
   */
  constructor(public guideService: TourGuideService) {
    this.dataSubscription = this.guideService.data$.subscribe((res: any) => {
      if (this.matSelect && res?.operation === 'open') {
        this.matSelect.open()
      }
      if (this.matSelect && res?.operation === 'close') {
        this.matSelect.close()
      }
      if (res.checkBox) {
        this.dataSource = new MatTableDataSource<any>(this.dataSource.data.map((el => { el.checkbox = true; return el })))
      } else this.dataSource = new MatTableDataSource<any>(this.dataSource.data.map((el => { el.checkbox = false; return el })))
    })
  }

  /** add quality gates */
  addQualityGates(item: any, event?: Event) {
    if(item.checkbox) {
      this.updQgCheckFlagChange.emit(true);
    }

    if (event) {
      const input = event.target as HTMLInputElement;
      if (input.value.length > 4) {
        input.value = input.value.slice(0, 4);
      }
    }

    if (!this.isEditable) {
      this.qualityGatesArray = [...this.dataSource.data];
      this.qualityGatesArray = this.qualityGatesArray.filter((el: any) => el.checkbox)
      this.addThreshHoldOutput.emit(this.qualityGatesArray)
      return;
    }

    let idx1 = this.thresholdTrueArray.findIndex((el: any) => el?.name === item?.name);

    for (let [key, value] of Object.entries(this.updateThreshHoldObj)) {
      let upIdx = this.updateThreshHoldObj[key].findIndex((el: any) => el?.name ? el.name == item.name : el == item.name);
      if (upIdx != -1) this.updateThreshHoldObj[key].splice(upIdx, 1);
    }

    if (idx1 !== -1 && JSON.stringify(item) != JSON.stringify(this.thresholdTrueArray[idx1])) {
      if (item.checkbox) {
        this.updateThresh('updated', item)
      } else {
        this.updateThresh('deleted', item)
      }
    } else if (idx1 == -1 && item.checkbox) {
      this.updateThresh('added', item)
    }
    this.addThreshHoldOutput.emit(this.updateThreshHoldObj)
  }

  /** update threshold of the quality gates */
  updateThresh(op: string, item: any) {
    let tempObj = { ...item }
    let upIdx = this.updateThreshHoldObj[op].findIndex((el: any) => el?.name ? el.name == item.name : el == item.name);

    delete tempObj.checkbox // delete checkbox property 

    if (upIdx != -1) {
      this.updateThreshHoldObj[op].splice(upIdx, 1, op == "deleted" ? tempObj.id : tempObj)
    } else {
      this.updateThreshHoldObj[op].push(op == "deleted" ? tempObj.id : tempObj)
    }
  }

  /** ngOnDestroy */
  ngOnDestroy(): void {
    this.dataSubscription.unsubscribe();
  }
}
